import { Card, Col, DatePicker, Layout, List, Row, Space, Typography, message } from "antd";
import axios from "axios";
import moment from "moment";
import React from "react";
import { paymentStatus, renderEstatusVenta } from "../../Utils";

const { Content } = Layout;
const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

class PaymentsType extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			cash: 0, // 1
			credit_card: 0, // 2
			zelle: 0, // 3
			venmo: 0, // 4
			other: 0, // 0 o null
			ventas: [],
			payment_method_selected: "total",
			ventas: {
				page: 1,
				limit: 10,
				total: 0,
			},
			filters: [],
		};
	}

	componentDidMount() {
		axios.defaults.headers.common["Authorization"] =
			sessionStorage.getItem("token");
		this.getInfo();
	}
	/**
	 * @method getInfo
	 * @description Obtiene la informacion de los tipos de pagos
	 */
	getInfo = () => {
		this.setState({ loading: true });

		let filters = [];

		if (this.state.fechas) {
			filters = [{
				filter: { range: this.state.fechas },
				name: 'fecha',
				objectName: 'fechas'
			}];
		}

		axios
			.get("/analytics-payments", { params: { filters } })
			.then((response) => {
				const paymentTotals = {
					cash: 0,
					credit_card: 0,
					zelle: 0,
					venmo: 0,
					other: 0,
				};

				response.data.forEach((payment) => {
					switch (payment._id) {
						case 1:
							paymentTotals.cash = payment.total;
							break;
						case 2:
							paymentTotals.credit_card = payment.total;
							break;
						case 3:
							paymentTotals.zelle = payment.total;
							break;
						case 4:
							paymentTotals.venmo = payment.total;
							break;
						case null:
						default:
							paymentTotals.other += payment.total;
							break;
					}
				});

				this.setState({ ...paymentTotals, loading: false }, () => this.getVentas());
			})
			.catch((error) => {
				console.log("error", error);
				this.setState({ loading: false });
			});
	};

	/**
	* @memberof onChangeDates
	* @description Actualiza las fechas de busqueda
	*/
	onChangeDates = (dates) => {
		if (dates) {
			this.setState({ fechas: dates }, () => { this.getInfo(); this.getVentas() })
		} else {
			this.setState({ fechas: undefined }, () => { this.getInfo(); this.getVentas() })
		}
	}

	/**
	 * @memberOf
	 * @method getVentas
	 * @description Obtiene ls lista de Ventas
	 */
	getVentas = (
		{
			page = this.state.ventas.page,
			limit = this.state.ventas.limit,
			search = this.state.ventas.search,
		} = this.state.ventas
	) => {
		this.setState({ loading: true });
		axios
			.get("/ventas", {
				params: {
					fechas: this.state.fechas,
					page: page,
					limit: limit,
					search: this.props.search,
					payment_method: this.state.payment_method_selected === "total"
						? null
						: this.state.payment_method_selected,
				},
			})
			.then(({ data }) => {
				console.log("ventas=>", data);
				this.setState({ ventas: data });
			})
			.catch((error) => {
				console.log(error);
				message.error(
					error?.response?.data?.message ??
					"Error when obtaining the information"
				);
			})
			.finally(() => this.setState({ loading: false }));
	};

	/**
	 * @method changePaymentType
	 * @description Cambia el tipo de pago seleccionado (si selecciona el mismo, limpia el filtro)
	 */
	changePaymentType = (type) => {
		this.setState(
			(prevState) => ({
				payment_method_selected:
					prevState.payment_method_selected === type ? "total" : type,
			}),
			() => {
				this.getVentas();
			}
		);
	};

	renderPaymentTypeTag = (type) => {
		const paymentNames = {
			1: "Cash",
			2: "Credit Card",
			3: "Zelle",
			4: "Venmo",
		};

		let result;

		if (type === 0 || type === null || type === undefined) {
			result = "None / Pending";
		} else {
			result = paymentNames[type] || "Other";
		}

		return <Text strong>{result}</Text>;
	};

	formatMoney = (amount) => {
		return `$${(amount ?? 0).toMoney(true)}`;
	};

	render() {
		const { payment_method_selected, ventas } = this.state;

		return (
			<Content>
				<Row gutter={[16, 16]}>
					<Col span={24}>
						<Space>
							{/*<Button
                            		onClick={()=>this.setState({visibleFilters: true})}
                            		icon={<FilterOutlined />}
                        		/>*/}
							<RangePicker
								style={{ width: "80%" }}
								onChange={this.onChangeDates}
								defaultValue={this.state.fechas}
							/>

						</Space>
					</Col>
					<Col xs={24} sm={12} md={8} lg={4}>
						<Card
							style={{ backgroundColor: payment_method_selected == 1 ? "#e6f7ff" : "transparent" }}
							size="small"
							hoverable
							onClick={() => this.changePaymentType(1)}
						>
							<Title level={5} className="m-0">Cash:</Title>
							<Title level={4} className="m-0">
								{this.formatMoney(this.state.cash)}
							</Title>
						</Card>
					</Col>

					<Col xs={24} sm={12} md={8} lg={4}>
						<Card
							style={{ backgroundColor: payment_method_selected == 2 ? "#e6f7ff" : "transparent" }}
							size="small"
							hoverable
							onClick={() => this.changePaymentType(2)}
						>
							<Title level={5} className="m-0">Credit Card:</Title>
							<Title level={4} className="m-0">
								{this.formatMoney(this.state.credit_card)}
							</Title>
						</Card>
					</Col>

					<Col xs={24} sm={12} md={8} lg={4}>
						<Card
							style={{ backgroundColor: payment_method_selected == 3 ? "#e6f7ff" : "transparent" }}
							size="small"
							hoverable
							onClick={() => this.changePaymentType(3)}
						>
							<Title level={5} className="m-0">Zelle:</Title>
							<Title level={4} className="m-0">
								{this.formatMoney(this.state.zelle)}
							</Title>
						</Card>
					</Col>

					<Col xs={24} sm={12} md={8} lg={4}>
						<Card
							style={{ backgroundColor: payment_method_selected == 4 ? "#e6f7ff" : "transparent" }}
							size="small"
							hoverable
							onClick={() => this.changePaymentType(4)}
						>
							<Title level={5} className="m-0">Venmo:</Title>
							<Title level={4} className="m-0">
								{this.formatMoney(this.state.venmo)}
							</Title>
						</Card>
					</Col>

					<Col xs={24} sm={12} md={8} lg={4}>
						<Card
							style={{ backgroundColor: payment_method_selected == 0 ? "#e6f7ff" : "transparent" }}
							size="small"
							hoverable
							onClick={() => this.changePaymentType(0)}
						>
							<Title level={5} className="m-0">None / Pending:</Title>
							<Title level={4} className="m-0">
								{this.formatMoney(this.state.other)}
							</Title>
						</Card>
					</Col>

					<Col xs={24} sm={12} md={8} lg={4}>
						<Card
							style={{ backgroundColor: payment_method_selected === "total" ? "#e6f7ff" : "transparent" }}
							size="small"
							hoverable
							onClick={() => this.changePaymentType("total")}
						>
							<Title level={5} className="m-0">Total:</Title>
							<Title level={4} className="m-0">
								{this.formatMoney(
									this.state.cash +
									this.state.credit_card +
									this.state.zelle +
									this.state.venmo +
									this.state.other
								)}
							</Title>
						</Card>
					</Col>

					<Col span={24}>
						<List
							loading={this.state.loading}
							className="component-list"
							itemLayout="horizontal"
							locale={{ emptyText: "Sales not found" }}
							dataSource={ventas.data}
							pagination={{
								current: ventas.page,
								pageSize: ventas.limit,
								total: ventas.total,
								pageSizeOptions: [10, 20, 50, 100, 500, 1000],
								position: "bottom",
								className: "flex-left ml-1",
								showSizeChanger: true,
								onChange: (page, limit) => {
									this.getVentas({ page, limit });
								},
							}}
							header={
								<Row align="middle">
									<Col flex="auto">
										<Row className="width-100 " align="middle" gutter={[0, 12]}>
											<Col xs={4} className="center" style={{ color: "gray" }}>
												<Text ellipsis strong>
													Folio / Client
												</Text>
											</Col>
											<Col xs={4} className="center">
												<Text ellipsis strong>
													Items
												</Text>
											</Col>

											<Col xs={4} className="center">
												<Text ellipsis strong>
													Status / Payment Status
												</Text>
											</Col>
											<Col xs={4} className="center">
												<Text ellipsis strong>
													Payment Method
												</Text>
											</Col>
											<Col xs={4} className="center">
												<Text ellipsis strong>
													Total
												</Text>
											</Col>
											<Col xs={4} className="center">
												<Text ellipsis strong>
													Date
												</Text>
											</Col>
										</Row>
									</Col>
								</Row>
							}
							renderItem={(item) => {
								console.log("Método de pago:", item.payment_method);
								return (
									<List.Item className="component-list-item">
										<Card className="card-list">
											<Row align="middle">
												<Col flex="auto">
													<Row className="width-100 " align="middle" gutter={[0, 12]}>
														<Col xs={4} className="flex-left-column">
															<small>
																{item.cliente_id?.nombre ?? "-"}{" "}
																{item.cliente_id?.apellidos}
															</small>
															<Text strong>{item.folio ?? "-"}</Text>
														</Col>
														<Col xs={4} className="flex-column">
															<Text ellipsis>
																{item?.detalles?.length
																	? item?.detalles?.reduce(function (
																		acc,
																		detalle
																	) {
																		return detalle?.servicio_id[0]?.tipo == 0
																			? acc + detalle.cantidad
																			: acc;
																	}, 0)
																	: 0}{" "}
																pairs{" "}
															</Text>
														</Col>

														<Col xs={4} className="center">
															<Text ellipsis>
																{renderEstatusVenta(item.status)}
															</Text>
															<Text ellipsis>
																{paymentStatus(item.square_payment)}
															</Text>
														</Col>
														<Col xs={4} className="center">
															{this.renderPaymentTypeTag(item.payment_method)}
														</Col>

														<Col xs={4} className="center">
															<Text ellipsis>$ {item.total?.toMoney(true)}</Text>
														</Col>

														<Col xs={4} className="flex-column">
															<Text ellipsis>
																{moment(item.createdAt).format(
																	"MM/DD/YYYY HH:mm"
																)}
															</Text>
														</Col>
													</Row>
												</Col>
											</Row>
										</Card>
									</List.Item>
								);
							}}

						/>
					</Col>
				</Row>
			</Content>
		);
	}
}

export default PaymentsType;
